export  const calculateEstimatedTime = (distance) => {
  // Assuming average speed of 800 km/h for jet aircraft
  const averageSpeed = 800; // in km/h
  const estimatedTime = distance / averageSpeed; // in hours
  return estimatedTime;
};